<!-- <div class="site-logo" id="logo">
  <a href=""><img src="../../../assets/images/logo.png" class="logo" /></a>
</div> -->

<div class="container main">
  <div class="" id="btn">
    <div class="filterRow">
      <div class="col text-right mt-3" >
        <button  
        class="btn btn-light hover-button-fetch fetchData"
        (click)="goBack()"
        style="width: 150px;"
      >
        <mat-icon>undo</mat-icon>
        <span class="name">Back</span>
      </button>
      
      
        <button
          class="btn btn-light hover-button-fetch fetchData"
          (click)="fetchNewData()"
        >
          <mat-icon>keyboard_backspace</mat-icon>
          <span class="name">Fetch Another Vessel </span>
        </button>

        <button
          class="btn btn-light hover-button-fetch fetchData1"type="button"
          (click)="print()"
          style="margin-right: 7px"
        >
          <mat-icon>print</mat-icon>
          <span class="name">Print</span>
        </button>
      </div>
    </div>
  </div>

  <div class="action-header-container" #filterContainer>
    <div class="modern-action-bar" style="margin-left: 0; margin-right: 0;">
      <div class="spacer"></div>
      <div class="right-filters" style="width: 100%;">
        <form [formGroup]="dashboardForm" class="filter-fields" style="width: 100%; display: flex; gap: 12px; align-items: flex-end;">
          
          <!-- Cargo -->
          <div class="compact-multi-select">
            <div class="select-box" (click)="toggleCargoDropdown($event)">
              <span>{{ selectedCargos.length ? (selectedCargos.length === cargooptions.length ? 'All Cargo'
                : selectedCargos.length + ' Cargo') : 'Select Cargo' }}</span>
              <mat-icon>expand_more</mat-icon>
            </div>
            <div class="dropdown-panel" *ngIf="cargoDropdownOpen" (click)="$event.stopPropagation()">
              <div class="search-container">
                <mat-icon>search</mat-icon>
                <input type="text" placeholder="Search Cargo..."
                  (input)="cargoSearchQuery = $any($event.target).value">
              </div>
              <div class="all-option" style="justify-content: space-between;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" (change)="toggleAllCargos($event)" [checked]="isAllCargosSelected()">
                  <span>Select All</span>
                </div>
                <span (click)="clearCargoFilter($event)" style="cursor: pointer; color: #6366f1; font-size: 12px; font-weight: 600;">Clear All</span>
              </div>
              <div class="options-list">
                <div class="option" *ngFor="let cargo of getFilteredCargos()">
                  <input type="checkbox" (change)="onCargoCheckboxChange($event, cargo)"
                    [checked]="selectedCargos.includes(cargo)">
                  <span>{{ cargo }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tanks -->
          <div class="compact-multi-select">
            <div class="select-box" (click)="toggleTankDropdown($event)">
              <span>{{ selectedTanks.length ? (selectedTanks.length === tankoptions.length ? 'All Tanks'
                : selectedTanks.length + ' Tanks') : 'Select Tank' }}</span>
              <mat-icon>expand_more</mat-icon>
            </div>
            <div class="dropdown-panel" *ngIf="tankDropdownOpen" (click)="$event.stopPropagation()">
              <div class="search-container">
                <mat-icon>search</mat-icon>
                <input type="text" placeholder="Search Tank..."
                  (input)="tankSearchQuery = $any($event.target).value">
              </div>
              <div class="all-option" style="justify-content: space-between;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" (change)="toggleAllTanks($event)" [checked]="isAllTanksSelected()">
                  <span>Select All</span>
                </div>
                <span (click)="clearTankFilter($event)" style="cursor: pointer; color: #6366f1; font-size: 12px; font-weight: 600;">Clear All</span>
              </div>
              <div class="options-list">
                <div class="option" *ngFor="let tank of getFilteredTanks()">
                  <input type="checkbox" (change)="onTankCheckboxChange($event, tank)"
                    [checked]="selectedTanks.includes(tank)">
                  <span>{{ tank }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Records -->
          <div class="compact-multi-select">
            <div class="select-box" (click)="toggleRecordsDropdown($event)">
              <span>{{ dashboardForm.get('records')?.value || 'Both' }}</span>
              <mat-icon>expand_more</mat-icon>
            </div>
            <div class="dropdown-panel" *ngIf="recordsDropdownOpen" (click)="$event.stopPropagation()">
              <div class="search-container">
                <mat-icon>search</mat-icon>
                <input type="text" placeholder="Search Records..."
                  (input)="recordsSearchQuery = $any($event.target).value">
              </div>
              <div class="options-list">
                <div class="option" *ngFor="let record of getFilteredRecords()" (click)="onRecordSelect(record)">
                  <span>{{ record }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- From Date -->
          <div class="compact-multi-select">
            <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">From:</label>
            <input type="date" class="form-control" formControlName="fromDate" style="height: 40px; background: rgba(255, 255, 255, 0.05); border: 1.5px solid rgba(255, 255, 255, 0.2); border-radius: 8px; color: white; padding: 0 12px;" />
          </div>

          <!-- To Date -->
          <div class="compact-multi-select">
            <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">To:</label>
            <input type="date" class="form-control" formControlName="toDate" style="height: 40px; background: rgba(255, 255, 255, 0.05); border: 1.5px solid rgba(255, 255, 255, 0.2); border-radius: 8px; color: white; padding: 0 12px;" />
          </div>

          <!-- ACTIONS -->
          <div class="filter-action-btns" style="display: flex; gap: 10px; align-items: center; margin-bottom: 0;">
            <button class="icon-btn clear" (click)="clearClick()" title="Reset Filters" type="button" style="background: rgba(255, 255, 255, 0.1); border-radius: 8px; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; border: 1.5px solid rgba(255, 255, 255, 0.2);">
              <mat-icon style="color: white; margin: 0;">clear_all</mat-icon>
            </button>
            <button class="icon-btn apply" (click)="updateCharts()" title="Apply Filters" type="button" style="background: #4a8ff4; border-radius: 8px; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; border: none;">
              <mat-icon style="color: white; margin: 0;">done</mat-icon>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- <div class="vessel-details">
    <div class="vessel-info">
      <p>
        <span class="vessel-label">Vessel Name:</span>
        <span class="vessel-value">{{ vesselName }}</span>
        <span class="vessel-label">IMO:</span>
        <span class="vessel-value">{{ vesselImo }}</span>
      </p>
    </div>
  </div> -->

  <div
    class="centerItems"
    [ngClass]="{ 'dark-filter': isDarkMode() }"
    id="printableArea"
  >
    <div class="container">
      <div class="graph-checkbox-container" *ngIf="!avgGraph">
        <div *ngFor="let tank of filteredOptions; let i = index">
          <div class="border" [ngClass]="{ 'dark-graph': isDarkMode() }">
            <div
              class="checkbox-container"
              style="border-radius: 2px; margin-left: 110px"
            >
              <label class="textpop">
                <input
                  class="inputCheckbox"
                  type="checkbox"
                  [(ngModel)]="showMeltPt"
                  (change)="updateChart()"
                />
                <span class="labelName">Melt Pt ({{ tank.Melt_Pts }}°C)</span>
              </label>
              <label class="textpop">
                <input
                  class="inputCheckbox"
                  type="checkbox"
                  [(ngModel)]="showLoadTemp"
                  (change)="updateChart()"
                />
                <span class="labelName"
                  >Loaded Temp ({{ tank.Load_Pts }}°C)</span
                >
              </label>
              <label class="textpop Cargo">
                <input
                  class="inputCheckbox"
                  type="checkbox"
                  [(ngModel)]="showCargoTemp"
                  (change)="updateChart()"
                />
                <span class="labelName">Cargo Temp</span>
              </label>
              <label class="textpop">
                <input
                  class="inputCheckbox"
                  type="checkbox"
                  [(ngModel)]="showVoyRange"
                  (change)="updateChart()"
                />
                <span class="labelName">
                  Voy Range ({{ tank.Voy_Range_Min }}°C -
                  {{ tank.Voy_Range_Max }}°C)
                </span>
              </label>
              <label class="textpop">
                <input
                  class="inputCheckbox"
                  type="checkbox"
                  [(ngModel)]="showDischRange"
                  (change)="updateChart()"
                />
                <span class="labelName">
                  Disch Range ({{ tank.Disch_Range_Min }}°C -
                  {{ tank.Disch_Range_Max }}°C)
                </span>
              </label>
              <label class="textpop">
                <input
                  class="inputCheckbox"
                  type="checkbox"
                  [(ngModel)]="showForecastTemp"
                  (change)="updateChart()"
                />
                <span class="labelName"> Forecast Temp</span>
              </label>
            </div>

            <!-- Chart Canvas -->
            <canvas [id]="'chart' + i"></canvas>
          </div>

          <div class="border" id="borderName">
            <p>
              {{
                tank.cargo_detail_list
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {{ tank.No_Tanks }}
            </p>
          </div>

          <!-- <div class="master-dates">
            <p><strong>Master Dates and Temps:</strong></p>
            <div *ngFor="let date of tank.master_dates; let temp of tank.Avg_Temp; let j = index">
               <span>{{ formatDate(date) }} - Avg Temp: {{ tank.Avg_Temp[j] }}°C - AVR FCT: {{ tank.AVR_FCT[j] }}</span> 
            </div>
          </div> -->

          <br />
        </div>
      </div>

      <!-- Main chart area -->
      <div class="chart main">
        <div
          class="centerItems"
          [ngClass]="{ 'dark-filter': isDarkMode() }"
          id="printableArea"
        ></div>
      </div>
    </div>

    <div *ngIf="avgGraph" class="avgGraph">
      <div class="container graphContainer">
        <div
          class="border"
          [ngClass]="{ 'dark-graph': isDarkMode() }"
          id="border"
        >
          <div
            class="checkbox-container avglegend"
            style="border-radius: 2px solid"
          >
            <label class="textpop">
              <input
                class="inputCheckbox"
                type="checkbox"
                [(ngModel)]="showMeltPt"
                (change)="updateChart()"
              />

              <span class="labelName"
                >Melt Pt ({{ this.fetchAverageTemp.Melt_Pts }}°C)</span
              >
            </label>
            <label class="textpop">
              <input
                class="inputCheckbox"
                type="checkbox"
                [(ngModel)]="showLoadTemp"
                (change)="updateChart()"
              />
              <span class="labelName"
                >Loaded Temp ({{ this.fetchAverageTemp.Load_Pts }}°C)</span
              >
            </label>
            <label class="textpop">
              <input
                class="inputCheckbox"
                type="checkbox"
                [(ngModel)]="showCargoTemp"
                (change)="updateChart()"
              />
              <span class="labelName">Cargo Temp</span>
            </label>

            <label class="textpop">
              <input
                class="inputCheckbox"
                type="checkbox"
                [(ngModel)]="showVoyRange"
                (change)="updateChart()"
              />
              <span class="labelName">
                Voy Range({{ this.fetchAverageTemp.Voy_Range_Min }}°C -
                {{ this.fetchAverageTemp.Voy_Range_Max }}°C)</span
              >
            </label>
            <label class="textpop">
              <input
                class="inputCheckbox"
                type="checkbox"
                [(ngModel)]="showDischRange"
                (change)="updateChart()"
              />
              <span class="labelName"
                >Dish Range({{ this.fetchAverageTemp.Disch_Range_Min }}°C -
                {{ this.fetchAverageTemp.Disch_Range_Max }}°C)</span
              >
            </label>

            <label class="textpop">
              <input
                class="inputCheckbox"
                type="checkbox"
                [(ngModel)]="showForecastTemp"
                (change)="updateChart()"
              />
              <span class="labelName"> Forecast Temp</span>
            </label>
            <label class="textpop">
              <input
                class="inputCheckbox"
                type="checkbox"
                [(ngModel)]="showAirTemp"
                (change)="updateChart()"
              />
              <span class="labelName"> Air Temp</span>
            </label>
            <label class="textpop">
              <input
                class="inputCheckbox"
                type="checkbox"
                [(ngModel)]="showSeaTemp"
                (change)="updateChart()"
              />
              <span class="labelName"> Sea Temp</span>
            </label>
          </div>
          <canvas id="secondCanvas"></canvas>
        </div>
        <div class="border" id="borderName">
          <p>AVERAGE CARGO TEMPERATURE AGAINST AIR AND SEA WATER TEMPERATURE</p>
        </div>
      </div>
    </div>
    <!-- <div class="footer" id="footer">
      <p style="margin-top: 90px">
        Meraki Shipping Services Pvt Ltd. "Value With Expertise" - (Tel: +91
        8521 7541 34) - Email:cargoheating"&#64;"merakishippingservices.com
      </p>
    </div> -->
  </div>



  <div class="gauge">
    <ng-container *ngIf="avgGraph">
      <app-gauge-chart [gaugeData]="gaugeData"></app-gauge-chart>
    </ng-container>
  </div>
</div>
